/* eslint-disable indent */
import React, { useEffect, useState } from "react";
import Profile from "../Profile/index";
import CpOnboardingNew from "../CpOnboardingNew";
//import CompanyList from "../CompanyBranch/BranchList";
import { Tabs } from "antd";
import "./style.scss";
import { useLocation } from "react-router-dom";
import constants from "../../constants/constants";
import Heading from "../../components/Heading";
import CompanyProfile from "../CpOnboardingNew/CompanyProfile";
import ClientCompanyProfile from "../../views/FirstMile/ClientCompanySteps";

import { getCurretRole, getUserAndPremiseId } from "../../utils";
import MasterCustomerList from "../Master/MasterLists/MasterCustomerList";
import urls from "../../api/urls";
const { GET_CLIENT_MASTER_LIST_V1, GET_COMPANY_MASTER_LIST_V1 } = urls;

const index = () => {
  const history = useLocation();
  const [key, setKey] = useState("0");

  const isKyc = true;
  //const currentEnv = process.env.REACT_APP_ENV;
  const getUserInfo = getUserAndPremiseId();
  const premiseId = getUserInfo?.premiseId;

  const onChange = (key) => {
    setKey(key);
  };
  useEffect(() => {
    setKey(history?.state?.tab || history?.state || "0");
  }, [history?.state]);

  const { ROLES } = constants;
  const { CP_ADMIN } = ROLES;

  const userData = JSON.parse(localStorage.getItem("userinfo"));
  const userRole = userData?.roles?.[0];

  const isClientAdmin = getCurretRole();

  return (
    <div className="profile-wrapper">
      <p
        className="pl-2 pr-2 pt-1 profile-heading"
        style={{ marginBottom: "-15px" }}
      >
        <Heading title={"Back"} navigateTo={"/dashboard"} />
      </p>
      <Tabs
        defaultActiveKey={"3"}
        activeKey={key}
        items={[
          {
            label: "User Profile",
            key: "0",
            children: <Profile />,
          },
          ...(userRole === CP_ADMIN
            ? [
                {
                  label: "CP Profile",
                  key: "1",
                  children: <CpOnboardingNew />,
                },
              ]
            : []),

          ...((userRole === CP_ADMIN && isKyc) || !isClientAdmin
            ? [
                {
                  label: "Company Profile",
                  key: "2",
                  children: <CompanyProfile />,
                },
              ]
            : []),
          ...(isClientAdmin
            ? [
                {
                  label: "Client Company Profile",
                  key: "2",
                  children: <ClientCompanyProfile />,
                },
              ]
            : []),
          ...(userRole === CP_ADMIN
            ? [
                {
                  label: "Company List",
                  key: "3",
                  children: (
                    <MasterCustomerList
                      userType={"COMPANY"}
                      tabKey={"3"}
                      url={"/profile"}
                      filter={{ cpId: premiseId }}
                      apiUrl={GET_COMPANY_MASTER_LIST_V1}
                    />
                  ),
                },
              ]
            : []),
          ...(userRole === CP_ADMIN
            ? [
                {
                  label: "My Client",
                  key: "4",
                  children: (
                    <MasterCustomerList
                      userType={"CLIENT"}
                      tabKey={"4"}
                      url={"/profile"}
                      filter={{ cpId: premiseId }}
                      apiUrl={GET_CLIENT_MASTER_LIST_V1}
                      role={"CP"}
                      basicEdit={true}
                      //actionEdit={true}
                    />
                  ),
                },
              ]
            : []),
        ]}
        onChange={onChange}
      />
    </div>
  );
};

export default index;
